@if (log().details?.length) {
  <div>
    @for (group of groupedDetails(); track group.key) {
      <ces-log-detail-item
        [details]="group.details"
        class="flex items-start gap-(--gap-normal) text-sm py-(--space-3) first:pt-(--space-1) border-b-1 last:border-0 last:pb-0" />
    }
  </div>
} @else {
  <div class="text-center py-(--space-4)">
    <div class="text-(color:--text-secondary) italic text-sm">{{ 'common.messages.noDetailsAvailable' | transloco }}</div>
  </div>
}
